import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import Select from 'components/select';

const SecondaryAccountDropdown = ({ options, isLoading }) => {
    const [order, setOrder] = useRecoilState(OrderPayload);

    if (isLoading || !options.length) return null;

    return (
        <Box sx={{ width: '100%' }} data-testid="secondary-account-dropdown-wrapper">
            <Select
                label="Secondary Account"
                dataTestId="secondary-account-select"
                options={options}
                value={order?.selectedSecondaryAccount?.secondaryAccountName || ''}
                handleOnSelect={(newValue) => {
                    setOrder((prev) => ({ ...prev, selectedSecondaryAccount: newValue || null }));
                }}
                isRequired
                disableClearable={false}
            />
        </Box>
    );
};

SecondaryAccountDropdown.propTypes = {
    options: PropTypes.array,
    isLoading: PropTypes.bool,
};

SecondaryAccountDropdown.defaultProps = {
    options: [],
    isLoading: false,
};

export default React.memo(SecondaryAccountDropdown);
